import { render, staticRenderFns } from "./IconTextButton.vue?vue&type=template&id=aa4ac25c&scoped=true"
import script from "./IconTextButton.vue?vue&type=script&lang=js"
export * from "./IconTextButton.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./IconTextButton.vue?vue&type=style&index=0&id=aa4ac25c&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./IconTextButton.vue?vue&type=style&index=1&id=aa4ac25c&prod&scoped=true&lang=css")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "aa4ac25c",
  null
  ,true
)

export default component.exports